module.exports = __webpack_public_path__ + "static/appleStore-972eef3a1785d26b4e0d2cb10cd79498.svg";